<form *ngIf="form != null" [formGroup]="form">
    <!-- Edit Mode Table: viewMode >= 2 -->
    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <div class="ham-table-scroll">
            <table class="ham-table">
                <!-- Segment Row -->
                <thead *ngIf="segments.length > 0">
                    <tr class="header-row">
                        <!-- empty placeholder segment for move icon column-->
                        <th class="hamScaleCol move-column">
                            <span></span>
                        </th>
                        <!-- empty placeholder segment for row title column-->
                        <th class="hamScaleCol title-column">
                            <span></span>
                        </th>
                        <div class="columns-container segments-wrapper" [style.flex]="xAxisConfigCols.length * 5">
                            <ng-container *ngFor="let col of xAxisConfigCols">
                                <ng-container *ngIf="startingColumnIdToSegment.has(col.columnId)">
                                    <!-- Calculate the total flex value of child columns -->
                                    <th
                                        class="segment"
                                        [style.flex]="getSegmentFlex(startingColumnIdToSegment.get(col.columnId))"
                                    >
                                        {{ startingColumnIdToSegment.get(col.columnId).title[language] }}
                                        <span
                                            class="ham-icon"
                                            (click)="editSegment(startingColumnIdToSegment.get(col.columnId))"
                                        >
                                            <i class="edit-icon"></i>
                                        </span>
                                        <span
                                            class="ham-icon"
                                            (click)="deleteSegment(startingColumnIdToSegment.get(col.columnId))"
                                        >
                                            <i class="trash-icon"></i>
                                        </span>
                                    </th>
                                </ng-container>
                                <ng-container *ngIf="!allColumnIdsUnderASegment.includes(col.columnId)">
                                    <th class="segment" [style.flex]="5">
                                        <span></span>
                                    </th>
                                </ng-container>
                            </ng-container>
                        </div>
                        <!-- empty placeholder segment for remove icon column-->
                        <th class="actions-column">
                            <span></span>
                        </th>
                    </tr>
                </thead>

                <!-- Header Row -->
                <thead>
                    <tr class="header-row" [ngClass]="{ 'extra-height': showCurrency}">
                        <th class="hamScaleCol move-column">
                            <span></span>
                        </th>
                        <th class="hamScaleCol title-column">
                            <!-- ham-referencing-input-component in Edit Mode -->
                            <ham-referencing-input-component
                                class="referencing-input"
                                [isEditMode]="viewMode === ViewMode.EDIT"
                                [title]="form.get('tableTitle').value"
                                [isReferenced]="addReferencing"
                                [isNumbered]="addNumbering"
                                [numbering]="tableNumber"
                                [width]="'400px'"
                                (titleChange)="onTitleChange($event)"
                                (addNumbering)="onAddNumberToggleChange($event)"
                                (addReferencing)="openReferenceDialog()"
                            ></ham-referencing-input-component>
                        </th>
                        <div class="columns-container" [style.flex]="xAxisConfigCols.length * 5">
                            <ng-container *ngFor="let col of xAxisConfigCols; let colIndex = index">
                                <ng-container *ngIf="col.type === 'CY'">
                                    <th class="hamScaleCol currentYear">
                                        <!-- Read-only header for current date -->
                                        <span
                                            [class.disabled]="!(colIndex !== 0)"
                                            class="ham-icon"
                                            (click)="moveColumnLeft(colIndex, col)"
                                        >
                                            <i class="chevron-left-icon"></i>
                                        </span>

                                        <span
                                            [class.disabled]="!(colIndex !== xAxisConfigCols.length - 1)"
                                            class="ham-icon"
                                            (click)="moveColumnRight(colIndex, col)"
                                        >
                                            <i class="chevron-right-icon"></i>
                                        </span>
                                        <span class="spacer"></span>
                                        <year-currency-input
                                            [yearLabel]="col.title ? col.title[language] : showFiscalYear ? (currentYearDate | date : 'yyyy') : (currentYearDate | dateLocale)"
                                            [currency]="getCurrencyForColumn(col)"
                                            [showCurrency]="showCurrency"
                                            (currencySave)="saveCurrencyForColumn(colIndex, $event)"
                                        ></year-currency-input>
                                        <span #menuTrigger class="ham-icon style-icon">
                                            <i
                                                class="dots-vertical-icon style-row-icon"
                                                (click)="toggleColumnStylingMenu(colIndex)"
                                                stopPropagation
                                            ></i>
                                        </span>
                                    </th>
                                    <!-- Styling Menu for Column -->
                                    <ham-styling-menu
                                        #menuContainer
                                        *ngIf="activeStyleMenuColumn === colIndex && !activeStyleMenuRow"
                                        class="styling-menu"
                                        [activeStyles]="col.format?.styles"
                                        (styleSelected)="applyColumnStyle(colIndex, $event)"
                                    ></ham-styling-menu>
                                </ng-container>

                                <!-- FX (REV-21512): display-currency twin of the current year — a real
                                     xAxisConfig column with the full CY header controls; only the cell
                                     values are computed. Renders only with FX context (G0). -->
                                <ng-container *ngIf="col.type === 'CY_FX' && fxNotesContext != null">
                                    <th class="hamScaleCol currentYear fx-twin-column">
                                        <span
                                            [class.disabled]="!(colIndex !== 0)"
                                            class="ham-icon"
                                            (click)="moveColumnLeft(colIndex, col)"
                                        >
                                            <i class="chevron-left-icon"></i>
                                        </span>
                                        <span
                                            [class.disabled]="!(colIndex !== xAxisConfigCols.length - 1)"
                                            class="ham-icon"
                                            (click)="moveColumnRight(colIndex, col)"
                                        >
                                            <i class="chevron-right-icon"></i>
                                        </span>
                                        <span class="spacer"></span>
                                        <year-currency-input
                                            [yearLabel]="col.title ? col.title[language] : showFiscalYear ? (currentYearDate | date : 'yyyy') : (currentYearDate | dateLocale)"
                                            [currency]="getCurrencyForColumn(col)"
                                            [showCurrency]="showCurrency"
                                            (currencySave)="saveCurrencyForColumn(colIndex, $event)"
                                        ></year-currency-input>
                                        <span #menuTrigger class="ham-icon style-icon">
                                            <i
                                                class="dots-vertical-icon style-row-icon"
                                                (click)="toggleColumnStylingMenu(colIndex)"
                                                stopPropagation
                                            ></i>
                                        </span>
                                    </th>
                                    <!-- Styling Menu for Column -->
                                    <ham-styling-menu
                                        #menuContainer
                                        *ngIf="activeStyleMenuColumn === colIndex && !activeStyleMenuRow"
                                        class="styling-menu"
                                        [activeStyles]="col.format?.styles"
                                        (styleSelected)="applyColumnStyle(colIndex, $event)"
                                    ></ham-styling-menu>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'PV' && compareYears">
                                    <th class="hamScaleCol previousYear">
                                        <!-- Read-only header for previous date -->

                                        <span
                                            [class.disabled]="!(colIndex !== 0)"
                                            class="ham-icon"
                                            (click)="moveColumnLeft(colIndex, col)"
                                        >
                                            <i class="chevron-left-icon"></i>
                                        </span>
                                        <span
                                            [class.disabled]="!(colIndex !== xAxisConfigCols.length - 1)"
                                            class="ham-icon"
                                            (click)="moveColumnRight(colIndex, col)"
                                        >
                                            <i class="chevron-right-icon"></i>
                                        </span>
                                        <span class="spacer"></span>
                                        <year-currency-input
                                            [yearLabel]="col.title ? col.title[language] : showFiscalYear && previousYearDate !== '-' ? (previousYearDate | date : 'yyyy') : (previousYearDate | dateLocale)"
                                            [currency]="getCurrencyForColumn(col)"
                                            [showCurrency]="showCurrency"
                                            (currencySave)="saveCurrencyForColumn(colIndex, $event)"
                                        ></year-currency-input>
                                        <span #menuTrigger class="ham-icon style-icon">
                                            <i
                                                class="dots-vertical-icon"
                                                (click)="toggleColumnStylingMenu(colIndex)"
                                                stopPropagation
                                            ></i>
                                        </span>
                                    </th>
                                    <!-- Styling Menu for Column -->
                                    <ham-styling-menu
                                        #menuContainer
                                        *ngIf="activeStyleMenuColumn === colIndex && !activeStyleMenuRow"
                                        class="styling-menu"
                                        [activeStyles]="col.format?.styles"
                                        (styleSelected)="applyColumnStyle(colIndex, $event)"
                                    ></ham-styling-menu>
                                </ng-container>

                                <!-- FX (REV-21512): display-currency twin of the previous year -->
                                <ng-container *ngIf="col.type === 'PV_FX' && fxNotesContext != null">
                                    <th class="hamScaleCol previousYear fx-twin-column">
                                        <span
                                            [class.disabled]="!(colIndex !== 0)"
                                            class="ham-icon"
                                            (click)="moveColumnLeft(colIndex, col)"
                                        >
                                            <i class="chevron-left-icon"></i>
                                        </span>
                                        <span
                                            [class.disabled]="!(colIndex !== xAxisConfigCols.length - 1)"
                                            class="ham-icon"
                                            (click)="moveColumnRight(colIndex, col)"
                                        >
                                            <i class="chevron-right-icon"></i>
                                        </span>
                                        <span class="spacer"></span>
                                        <year-currency-input
                                            [yearLabel]="col.title ? col.title[language] : showFiscalYear && previousYearDate !== '-' ? (previousYearDate | date : 'yyyy') : (previousYearDate | dateLocale)"
                                            [currency]="getCurrencyForColumn(col)"
                                            [showCurrency]="showCurrency"
                                            (currencySave)="saveCurrencyForColumn(colIndex, $event)"
                                        ></year-currency-input>
                                        <span #menuTrigger class="ham-icon style-icon">
                                            <i
                                                class="dots-vertical-icon style-row-icon"
                                                (click)="toggleColumnStylingMenu(colIndex)"
                                                stopPropagation
                                            ></i>
                                        </span>
                                    </th>
                                    <!-- Styling Menu for Column -->
                                    <ham-styling-menu
                                        #menuContainer
                                        *ngIf="activeStyleMenuColumn === colIndex && !activeStyleMenuRow"
                                        class="styling-menu"
                                        [activeStyles]="col.format?.styles"
                                        (styleSelected)="applyColumnStyle(colIndex, $event)"
                                    ></ham-styling-menu>
                                </ng-container>

                                <ng-container
                                    *ngIf="col.type === 'NUMBER' || col.type === 'TEXT' || col.type === 'CALC'"
                                >
                                    <th
                                        class="hamScaleCol extra-column"
                                        [ngClass]="{
                                            currentYear: col.belongingYear === 'CY',
                                            previousYear: col.belongingYear === 'PV'
                                        }"
                                    >
                                        <div class="input-and-actions-container">
                                            <span
                                                [class.disabled]="!(colIndex !== 0)"
                                                class="ham-icon"
                                                (click)="moveColumnLeft(colIndex, col)"
                                            >
                                                <i class="chevron-left-icon"></i>
                                            </span>
                                            <span
                                                [class.disabled]="!(colIndex !== xAxisConfigCols.length - 1)"
                                                class="ham-icon"
                                                (click)="moveColumnRight(colIndex, col)"
                                            >
                                                <i class="chevron-right-icon"></i>
                                            </span>
                                            <div class="input-container">
                                                <year-currency-input
                                                    [currency]="getCurrencyForColumn(col)"
                                                    [showCurrency]="showCurrency"
                                                    [alignEnd]="false"
                                                    (currencySave)="saveCurrencyForColumn(colIndex, $event)"
                                                >
                                                    <input
                                                        class="extra-column-title-input"
                                                        hamInput
                                                        type="text"
                                                        value="{{ col.title[language] }}"
                                                        (input)="onChangeColumnTitle($event, col)"
                                                    />
                                                </year-currency-input>
                                            </div>
                                            <span #menuTrigger class="ham-icon">
                                                <i
                                                    class="dots-vertical-icon"
                                                    (click)="toggleColumnContextMenu(colIndex, $event)"
                                                    stopPropagation
                                                ></i>
                                            </span>
                                        </div>
                                    </th>

                                    <ham-styling-menu
                                        #menuContainer
                                        *ngIf="activeStyleMenuColumn === colIndex && !activeStyleMenuRow"
                                        class="styling-menu"
                                        [activeStyles]="col.format?.styles"
                                        (styleSelected)="applyColumnStyle(colIndex, $event)"
                                    ></ham-styling-menu>
                                </ng-container>
                            </ng-container>
                        </div>

                        <th class="actions-column add-column-icon">
                            <ham-button
                                class="actions-icon"
                                data-testid="super-table-add-column"
                                icon="assets/hamIcons/circle-plus.svg"
                                type="submit"
                                variant="gray-round-small"
                                (click)="
                                    !transpose && xAxisConfigCols.length >= 7 ? '' : (openAddNewColumnDialog = true)
                                "
                                hideText="true"
                                [disabled]="!transpose && xAxisConfigCols.length >= 7"
                            ></ham-button>
                        </th>
                    </tr>
                </thead>

                <!-- Data Rows -->
                <tbody formArrayName="rows">
                    <div cdkDropList (cdkDropListDropped)="dropRow($event)">
                        <tr
                            *ngFor="let row of form.get('rows')['controls']; let i = index"
                            [formGroupName]="i"
                            cdkDrag
                            cdkDragLockAxis="y"
                            cdkDragPreviewContainer="parent"
                            (cdkDragMoved)="onRowDragMoved($event)"
                            (cdkDragEnded)="onRowDragEnded()"
                        >
                            <td class="hamScaleCol move-column">
                                <span class="ham-icon dots-vertical" cdkDragHandle>
                                    <i class="dots-grid-icon"></i>
                                </span>
                            </td>
                            <td
                                class="hamScaleCol title-column"
                                [ngClass]="{
                                    'blue-bordered-cell': row.get('type').value === 'CALC'
                                }"
                                [class.title-cell]="row.get('type')?.value === 'TITLE' || row.get('type')?.value === 'TEXT_ROW'"
                            >
                                <input
                                    *ngIf="row.get('type').value !== 'SPACE'"
                                    hamInput
                                    [aumicoStyleOptions]="resolveEffectiveCellStyles(row.get('format')?.value)"
                                    type="text"
                                    [formControl]="row.get('title')"
                                />

                                <span class="empty-cell" *ngIf="row.get('type').value === 'SPACE'"></span>
                            </td>
                            <div class="columns-container" [style.flex]="xAxisConfigCols.length * 5">
                                <ng-container *ngFor="let col of xAxisConfigCols">
                                    <!-- Current Year -->
                                    <td
                                        *ngIf="col.type === 'CY'"
                                        class="hamScaleCol currentYear"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC',
                                            todoHighlight:
                                                highlightTodos &&
                                                (row.get('currentValue')?.value === '' ||
                                                    row.get('currentValue')?.value === 0 ||
                                                    row.get('currentValue')?.value === '-' ||
                                                    row.get('currentValue')?.value == null) &&
                                                row.get('type').value !== 'SPACE'
                                        }"
                                        [class.as-disabled]="
                                            !(
                                                row.get('type')?.value === 'FREE_TEXT' ||
                                                row.get('type')?.value === 'SPACE' ||
                                                row.get('type')?.value === 'TITLE' ||
                                                row.get('type')?.value === 'TEXT_ROW'
                                            )
                                        "
                                        [class.title-cell]="row.get('type')?.value === 'TITLE' || row.get('type')?.value === 'TEXT_ROW'"
                                    >
                                        <input
                                            *ngIf="
                                                row.get('type').value !== 'SPACE' &&
                                                row.get('type').value !== 'TITLE' &&
                                                row.get('type').value !== 'TEXT_ROW'
                                            "
                                            hamInput
                                            [invalidRef]="isCellInvalid(row.get('rowId').value, col.columnId)"
                                            [readonly]="
                                                !(
                                                    row.get('type')?.value === 'FREE_TEXT' ||
                                                    row.get('type')?.value === 'SPACE' ||
                                                    row.get('type')?.value === 'TITLE' ||
                                                    row.get('type')?.value === 'TEXT_ROW'
                                                )
                                            "
                                            [prefixIcon]="
                                                row.get('reconcileItems')?.value != null &&
                                                !row.get('reconcilationCurrentYearMismatch')?.value
                                                    ? 'assets/hamIcons/check-circle.svg'
                                                    : row.get('reconcileItems')?.value != null &&
                                                      row.get('reconcilationCurrentYearMismatch')?.value
                                                    ? 'assets/hamIcons/x-circle-red.svg'
                                                    : undefined
                                            "
                                            [iconColor]="
                                                row.get('reconcileItems')?.value != null &&
                                                !row.get('reconcilationCurrentYearMismatch')?.value
                                                    ? '#0E9F6E'
                                                    : row.get('reconcileItems')?.value != null &&
                                                      row.get('reconcilationCurrentYearMismatch')?.value
                                                    ? '#E02424'
                                                    : undefined
                                            "
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [decimalPlaces]="
                                                resolveEffectiveDecimalPlaces(row.get('format')?.value, col.format)
                                            "
                                            type="number"
                                            class="number-input"
                                            [formControl]="row.get('currentValue')"
                                            [placeholder]="
                                                'aumico_notes_super_table_current_value_placeholder' | i18next
                                            "
                                        />
                                        <!-- Title Row and Text Row shall have text input -->
                                        <input
                                            *ngIf="row.get('type').value === 'TITLE' || row.get('type').value === 'TEXT_ROW'"
                                            hamInput
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [formControl]="row.get('currentValue')"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>

                                    <!-- FX (REV-21512): display-currency twin cell (current year) — editable on user
                                         rows exactly like the functional column, computed and read-only otherwise -->
                                    <td
                                        *ngIf="col.type === 'CY_FX' && fxNotesContext != null"
                                        class="hamScaleCol currentYear fx-twin-column"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC'
                                        }"
                                        [class.as-disabled]="
                                            !(
                                                row.get('type')?.value === 'FREE_TEXT' ||
                                                row.get('type')?.value === 'SPACE' ||
                                                row.get('type')?.value === 'TITLE' ||
                                                row.get('type')?.value === 'TEXT_ROW'
                                            )
                                        "
                                        [class.title-cell]="row.get('type')?.value === 'TITLE' || row.get('type')?.value === 'TEXT_ROW'"
                                    >
                                        <input
                                            *ngIf="row.get('type').value !== 'SPACE' && row.get('type').value !== 'TITLE' && row.get('type').value !== 'TEXT_ROW'"
                                            hamInput
                                            type="number"
                                            class="number-input"
                                            [aumicoStyleOptions]="resolveEffectiveCellStyles(row.get('format')?.value, col.format)"
                                            [decimalPlaces]="row.get('type').value === fxRateRowType ? 5 : resolveEffectiveDecimalPlaces(row.get('format')?.value, col.format)"
                                            [formControl]="
                                                row.get('type').value === 'FREE_TEXT'
                                                    ? row.get(col.columnId)
                                                    : fxCellControl(row.get('rowId').value, 'cy')
                                            "
                                            [readonly]="row.get('type').value !== 'FREE_TEXT'"
                                            [placeholder]="
                                                row.get('type').value === 'FREE_TEXT'
                                                    ? ('aumico_notes_super_table_current_value_placeholder' | i18next)
                                                    : ''
                                            "
                                        />
                                        <!-- Title Row and Text Row shall have text input -->
                                        <input
                                            *ngIf="row.get('type').value === 'TITLE' || row.get('type').value === 'TEXT_ROW'"
                                            hamInput
                                            [aumicoStyleOptions]="resolveEffectiveCellStyles(row.get('format')?.value, col.format)"
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>

                                    <!-- Previous Year -->

                                    <td
                                        *ngIf="compareYears && col.type === 'PV'"
                                        class="hamScaleCol previousYear"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC',
                                            todoHighlight:
                                                highlightTodos &&
                                                (row.get('previousValue')?.value === '' ||
                                                    row.get('previousValue')?.value === 0 ||
                                                    row.get('previousValue')?.value === '-' ||
                                                    row.get('previousValue')?.value == null) &&
                                                row.get('type').value !== 'SPACE'
                                        }"
                                        [class.as-disabled]="
                                            !(
                                                row.get('type')?.value === 'FREE_TEXT' ||
                                                row.get('type')?.value === 'SPACE' ||
                                                row.get('type')?.value === 'TITLE' ||
                                                row.get('type')?.value === 'TEXT_ROW'
                                            )
                                        "
                                        [class.title-cell]="row.get('type')?.value === 'TITLE' || row.get('type')?.value === 'TEXT_ROW'"
                                    >
                                        <input
                                            *ngIf="
                                                row.get('type').value !== 'SPACE' &&
                                                row.get('type').value !== 'TITLE' &&
                                                row.get('type').value !== 'TEXT_ROW'
                                            "
                                            hamInput
                                            [invalidRef]="isCellInvalid(row.get('rowId').value, col.columnId)"
                                            [readonly]="
                                                !(
                                                    row.get('type')?.value === 'FREE_TEXT' ||
                                                    row.get('type')?.value === 'SPACE' ||
                                                    row.get('type')?.value === 'TITLE' ||
                                                    row.get('type')?.value === 'TEXT_ROW'
                                                )
                                            "
                                            [prefixIcon]="
                                                row.get('reconcileItems')?.value != null &&
                                                !row.get('reconcilationPreviousYearMismatch')?.value
                                                    ? 'assets/hamIcons/check-circle.svg'
                                                    : row.get('reconcileItems')?.value != null &&
                                                      row.get('reconcilationPreviousYearMismatch')?.value
                                                    ? 'assets/hamIcons/x-circle-red.svg'
                                                    : undefined
                                            "
                                            [iconColor]="
                                                row.get('reconcileItems')?.value != null &&
                                                !row.get('reconcilationPreviousYearMismatch')?.value
                                                    ? '#0E9F6E'
                                                    : row.get('reconcileItems')?.value != null &&
                                                      row.get('reconcilationPreviousYearMismatch')?.value
                                                    ? '#E02424'
                                                    : undefined
                                            "
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [decimalPlaces]="
                                                resolveEffectiveDecimalPlaces(row.get('format')?.value, col.format)
                                            "
                                            type="number"
                                            class="number-input"
                                            [formControl]="row.get('previousValue')"
                                            [placeholder]="
                                                'aumico_notes_super_table_previous_value_placeholder' | i18next
                                            "
                                        />
                                        <!-- Title Row and Text Row shall have text input -->
                                        <input
                                            *ngIf="row.get('type').value === 'TITLE' || row.get('type').value === 'TEXT_ROW'"
                                            hamInput
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [formControl]="row.get('previousValue')"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>
                                    <!-- FX (REV-21512): display-currency twin cell (previous year) — editable on user
                                         rows exactly like the functional column, computed and read-only otherwise -->
                                    <td
                                        *ngIf="col.type === 'PV_FX' && fxNotesContext != null"
                                        class="hamScaleCol previousYear fx-twin-column"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC'
                                        }"
                                        [class.as-disabled]="
                                            !(
                                                row.get('type')?.value === 'FREE_TEXT' ||
                                                row.get('type')?.value === 'SPACE' ||
                                                row.get('type')?.value === 'TITLE' ||
                                                row.get('type')?.value === 'TEXT_ROW'
                                            )
                                        "
                                        [class.title-cell]="row.get('type')?.value === 'TITLE' || row.get('type')?.value === 'TEXT_ROW'"
                                    >
                                        <input
                                            *ngIf="row.get('type').value !== 'SPACE' && row.get('type').value !== 'TITLE' && row.get('type').value !== 'TEXT_ROW'"
                                            hamInput
                                            type="number"
                                            class="number-input"
                                            [aumicoStyleOptions]="resolveEffectiveCellStyles(row.get('format')?.value, col.format)"
                                            [decimalPlaces]="row.get('type').value === fxRateRowType ? 5 : resolveEffectiveDecimalPlaces(row.get('format')?.value, col.format)"
                                            [formControl]="
                                                row.get('type').value === 'FREE_TEXT'
                                                    ? row.get(col.columnId)
                                                    : fxCellControl(row.get('rowId').value, 'py')
                                            "
                                            [readonly]="row.get('type').value !== 'FREE_TEXT'"
                                            [placeholder]="
                                                row.get('type').value === 'FREE_TEXT'
                                                    ? ('aumico_notes_super_table_previous_value_placeholder' | i18next)
                                                    : ''
                                            "
                                        />
                                        <!-- Title Row and Text Row shall have text input -->
                                        <input
                                            *ngIf="row.get('type').value === 'TITLE' || row.get('type').value === 'TEXT_ROW'"
                                            hamInput
                                            [aumicoStyleOptions]="resolveEffectiveCellStyles(row.get('format')?.value, col.format)"
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>

                                    <!-- Number Column -->
                                    <td
                                        *ngIf="col.type === 'NUMBER'"
                                        class="hamScaleCol extra-column"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC',
                                            currentYear: col.belongingYear === 'CY',
                                            previousYear: col.belongingYear === 'PV',
                                            todoHighlight:
                                                highlightTodos &&
                                                (row.get(col.columnId)?.value === '' ||
                                                    row.get(col.columnId)?.value === 0 ||
                                                    row.get(col.columnId)?.value === '-' ||
                                                    row.get(col.columnId)?.value == null) &&
                                                row.get('type').value !== 'SPACE'
                                        }"
                                        [class.as-disabled]="row.get('type')?.value === 'CALC'"
                                    >
                                        <input
                                            *ngIf="
                                                row.get('type').value !== 'SPACE' &&
                                                row.get('type').value !== 'TITLE' &&
                                                row.get('type').value !== 'TEXT_ROW'
                                            "
                                            hamInput
                                            [invalidRef]="isCellInvalid(row.get('rowId').value, col.columnId)"
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [decimalPlaces]="
                                                resolveEffectiveDecimalPlaces(row.get('format')?.value, col.format)
                                            "
                                            type="number"
                                            class="number-input"
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="
                                                'aumico_notes_super_table_numeric_value_placeholder' | i18next
                                            "
                                        />
                                        <!-- Title Row and Text Row shall have text input -->
                                        <input
                                            *ngIf="row.get('type').value === 'TITLE' || row.get('type').value === 'TEXT_ROW'"
                                            hamInput
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>

                                    <!-- Calculation Column -->
                                    <td
                                        *ngIf="col.type === 'CALC'"
                                        class="hamScaleCol extra-column"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC',
                                            currentYear: col.belongingYear === 'CY',
                                            previousYear: col.belongingYear === 'PV',
                                            todoHighlight:
                                                highlightTodos &&
                                                (row.get(col.columnId)?.value === '' ||
                                                    row.get(col.columnId)?.value === 0 ||
                                                    row.get(col.columnId)?.value === '-' ||
                                                    row.get(col.columnId)?.value == null) &&
                                                row.get('type').value !== 'SPACE'
                                        }"
                                        [class.as-disabled]="
                                            row.get('type').value !== 'SPACE' &&
                                            row.get('type').value !== 'TITLE' &&
                                            row.get('type').value !== 'TEXT_ROW'
                                        "
                                        [class.title-cell]="row.get('type')?.value === 'TITLE' || row.get('type')?.value === 'TEXT_ROW'"
                                    >
                                        <input
                                            *ngIf="
                                                row.get('type').value !== 'SPACE' &&
                                                row.get('type').value !== 'TITLE' &&
                                                row.get('type').value !== 'TEXT_ROW'
                                            "
                                            hamInput
                                            [invalidRef]="isCellInvalid(row.get('rowId').value, col.columnId)"
                                            [readonly]="true"
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [decimalPlaces]="
                                                resolveEffectiveDecimalPlaces(row.get('format')?.value, col.format)
                                            "
                                            type="number"
                                            class="number-input"
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="
                                                'aumico_notes_super_table_numeric_value_placeholder' | i18next
                                            "
                                        />
                                        <!-- Title Row and Text Row shall have text input -->
                                        <input
                                            *ngIf="row.get('type').value === 'TITLE' || row.get('type').value === 'TEXT_ROW'"
                                            hamInput
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>
                                    <td
                                        *ngIf="col.type === 'TEXT'"
                                        class="hamScaleCol extra-column"
                                        [ngClass]="{
                                            'blue-bordered-cell': row.get('type').value === 'CALC',
                                            currentYear: col.belongingYear === 'CY',
                                            previousYear: col.belongingYear === 'PV',
                                            todoHighlight:
                                                highlightTodos &&
                                                (row.get(col.columnId)?.value == null ||
                                                    row.get(col.columnId)?.value === 0 ||
                                                    ('' + row.get(col.columnId)?.value).trim() === '' ||
                                                    ('' + row.get(col.columnId)?.value).trim() === '-') &&
                                                row.get('type').value !== 'SPACE'
                                        }"
                                        [class.as-disabled]="row.get('type').value === 'CALC'"
                                    >
                                        <input
                                            *ngIf="row.get('type').value !== 'SPACE'"
                                            hamInput
                                            [invalidRef]="isCellInvalid(row.get('rowId').value, col.columnId)"
                                            [aumicoStyleOptions]="
                                                resolveEffectiveCellStyles(row.get('format')?.value, col.format)
                                            "
                                            [formControl]="row.get(col.columnId)"
                                            [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
                                        />
                                    </td>
                                </ng-container>
                            </div>
                            <!-- Actions Column -->
                            <td class="actions-column" (click)="toggleRowContextMenu(i, $event)">
                                <div class="input-and-actions-container">
                                    <span #menuTrigger class="ham-icon action-column-icon">
                                        <i class="dots-vertical-icon"></i>
                                    </span>
                                </div>
                            </td>
                            <!-- Styling Menu for Row -->
                            <ham-styling-menu
                                #menuContainer
                                *ngIf="activeStyleMenuRow === i && !activeStyleMenuColumn"
                                class="styling-menu"
                                [ngClass]="{
                                    lastRow: form.get('rows')['controls'].length - 1 === i
                                }"
                                [activeStyles]="row.get('format')?.value.styles"
                                (styleSelected)="applyRowStyle(i, $event)"
                            ></ham-styling-menu>
                        </tr>
                    </div>
                </tbody>
            </table>
        </div>
        <!-- EMPTY STATE -->
        <div *ngIf="form.get('rows')['controls'].length === 0" class="empty-state-wrapper">
            <div class="empty-state">
                <img src="assets/images/aumico-super-table-card-popup1.svg" />
                <div class="text1">
                    {{ 'aumico_notes_empty_state_text_1' | i18next }}
                </div>
                <div class="text2">
                    {{ 'aumico_notes_empty_state_text_2' | i18next }}
                </div>
                <ham-button
                    type="submit"
                    (buttonClick)="openAddNewRowDialog = true"
                    icon="assets/hamIcons/plus-outline.svg"
                >
                    {{ 'aumico_notes_add_row_text' | i18next }}
                </ham-button>
            </div>
        </div>
        <ham-button
            class="add-row-icon"
            data-testid="super-table-add-row"
            icon="assets/hamIcons/circle-plus.svg"
            type="submit"
            variant="gray-round-small"
            (click)="openAddNewRowDialog = true"
            hideText="true"
        ></ham-button>
        <!-- Footnote Section -->
        <div class="footnote-section" *ngIf="hasFootnotes">
            <label for="footnote">{{ 'aumico_notes_footnote_label' | i18next }}</label>
            <textarea
                hamInput
                [hideRemoveXButton]="true"
                [formControl]="form.controls['footnote']"
                [placeholder]="'aumico_notes_footnote_placeholder' | i18next"
            ></textarea>
        </div>
    </ng-container>

    <div *ngIf="showPreviousYear" class="previous-year-table">
        <super-table-notes-preview
            [sectionNotes]="previousYearPreviewData"
            colored="true"
            [highlightTodos]="highlightTodos"
        >
        </super-table-notes-preview>
    </div>
</form>

<ham-modal
    *ngIf="openAddNewRowDialog"
    title="{{ 'aumico_notes_super_table_add_row' | i18next }}"
    (cancel)="openAddNewRowDialog = false"
    [size]="'lg'"
>
    <add-row [fxEnabled]="fxNotesContext != null" (selectedOption)="addNewRow($event)"></add-row>
</ham-modal>

<ham-modal
    *ngIf="openAddNewColumnDialog"
    title="{{ 'aumico_notes_super_table_add_column' | i18next }}"
    (cancel)="openAddNewColumnDialog = false"
    [size]="'lg'"
>
    <add-column (selectedOption)="addNewColumn($event)"></add-column>
</ham-modal>

<!-- USED FOR ADDING NEW ROW FROM BALANCE -->
<ham-modal
    *ngIf="openAddNewRowFromBalance"
    title="{{ 'aumico_notes_super_table_data_selection_title' | i18next }}"
    [saveText]="'aumico_notes_super_table_add_row' | i18next"
    (save)="handleMappingRowSettings()"
    (cancel)="openAddNewRowFromBalance = false; currentMappingRowSettings = null"
    [size]="'l'"
>
    <super-table-mapping-row-settings
        [matchingMappingItemsSelectionTree]="balanceMappingItemsSelectionTree"
        [language]="language"
        (mappingRowSettings)="onMappingRowSettingsChange($event)"
    >
    </super-table-mapping-row-settings>
</ham-modal>

<!-- USED FOR ADDING NEW ROW FROM INCOME -->
<ham-modal
    *ngIf="openAddNewRowFromIncome"
    title="{{ 'aumico_notes_super_table_data_selection_title' | i18next }}"
    [saveText]="'aumico_notes_super_table_add_row' | i18next"
    (save)="handleMappingRowSettings()"
    (cancel)="openAddNewRowFromIncome = false; currentMappingRowSettings = null"
    [size]="'l'"
>
    <super-table-mapping-row-settings
        [matchingMappingItemsSelectionTree]="incomeMappingItemsSelectionTree"
        [language]="language"
        (mappingRowSettings)="onMappingRowSettingsChange($event)"
    >
    </super-table-mapping-row-settings>
</ham-modal>

<!-- USED FOR EDITING MAPPING ROW SETTINGS-->
<ham-modal
    *ngIf="openAddNewRowFromBalanceOrIncome"
    title="{{ 'aumico_notes_super_table_edit_row' | i18next }}"
    [saveText]="'aumico_notes_super_table_edit_row' | i18next"
    (save)="handleMappingRowSettings()"
    (cancel)="openAddNewRowFromBalanceOrIncome = false; currentMappingRowSettings = null"
    [size]="'l'"
    stopPropagation
>
    <super-table-mapping-row-settings
        [allMappingItemsSelectionTree]="allMappingItemsSelectionTree"
        [balanceMappingItemsSelectionTree]="balanceMappingItemsSelectionTree"
        [incomeMappingItemsSelectionTree]="incomeMappingItemsSelectionTree"
        [language]="language"
        [existingRow]="form.get('rows').value[activeContextMenuRow]"
        (mappingRowSettings)="onMappingRowSettingsChange($event)"
    >
    </super-table-mapping-row-settings>
</ham-modal>

<ham-modal
    *ngIf="reconcilePopUpOpened"
    title="{{ 'aumico_notes_super_table_reconcile' | i18next }}"
    [saveText]="'aumico_notes_super_table_reconcile' | i18next"
    (cancel)="onCancelReconcile()"
    [size]="'l'"
    (save)="onSaveReconcileSelection()"
    stopPropagation
>
    <super-table-reconcile
        [mappingItemsSelectionTree]="allMappingItemsSelectionTree"
        [existingReconcileSelectionItems]="form.get('rows').value[activeContextMenuRow].reconcileItems"
        [language]="language"
        (selectedItem)="onReconcileSelectedItemsChange($event)"
    ></super-table-reconcile>
</ham-modal>

<ham-confirm-decline-modal
    *ngIf="showColumnDeletionDialog"
    (cancel)="onCancelDeleteColumn()"
    (action)="onDeleteColumn()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_notes_super_table_delete_column_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    *ngIf="showRowDeletionDialog"
    (cancel)="onCancelRowDeletion()"
    (action)="onDeleteRow()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_notes_super_table_delete_row_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<ham-modal
    *ngIf="openCalculationFunctionSelection"
    title="{{
        currentSelectedAxis === 'ROW'
            ? ('aumico_notes_super_table_add_calculation_row_title' | i18next)
            : ('aumico_notes_super_table_add_calculation_column_title' | i18next)
    }}"
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(false)"
    [size]="'l'"
    stopPropagation
>
    <calculation-function-selection
        (selectedCalculationFunction)="onCalculationFunctionSelection($event)"
    ></calculation-function-selection>
</ham-modal>

<!-- FX (REV-21512): source picker for a new rate row — the RATE mirror of the calculation modal -->
<ham-modal
    *ngIf="openRateSourceSelection"
    title="{{ 'aumico_notes_super_table_add_rate_row_title' | i18next }}"
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelRateSourceSelection()"
    [size]="'l'"
    stopPropagation
>
    <rate-source-selection (selectedRateSource)="onRateSourceSelection($event)"></rate-source-selection>
</ham-modal>

<!-- Calculations for Rows -->
<ham-modal
    *ngIf="openSummationRowDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_summation' | i18next }}"
    titleIcon="sigma-icon"
    [saveText]="
        currentCalculationOutput != null && currentCalculationOutput.rowSelections.length !== 0
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationRow()"
    stopPropagation
>
    <super-table-summation-row
        [selectionOptions]="rowSelections"
        [existingCalculation]="currentSelectedCalculation"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-summation-row>
</ham-modal>

<ham-modal
    *ngIf="openMultiplicationRowDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_multiplication' | i18next }}"
    titleIcon="x-outline-icon"
    [saveText]="
        currentCalculationOutput != null && currentCalculationOutput.rowSelections.length > 1
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationRow()"
    stopPropagation
>
    <super-table-multiplication-row
        [selectionOptions]="rowSelections"
        [existingCalculation]="currentSelectedCalculation"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-multiplication-row>
</ham-modal>

<ham-modal
    *ngIf="openSubtractionRowDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_subtraction' | i18next }}"
    titleIcon="minus-icon"
    [saveText]="
        currentCalculationOutput != null &&
        currentCalculationOutput.rowSelections[0] != null &&
        currentCalculationOutput.rowSelections[1] != null
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationRow()"
    stopPropagation
>
    <super-table-subtraction-row
        [selectionOptions]="rowSelections"
        [existingCalculation]="currentSelectedCalculation"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-subtraction-row>
</ham-modal>

<ham-modal
    *ngIf="openRatioRowDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_ratio' | i18next }}"
    titleIcon="chart-pie-outline-icon"
    [saveText]="
        currentCalculationOutput != null &&
        currentCalculationOutput.rowSelections.length !== 0 &&
        currentCalculationOutput.relationItem != null
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationRow()"
    stopPropagation
>
    <super-table-ratio-row
        [rowSelectionOptions]="rowSelections"
        [columnSelectionOptions]="columnSelections"
        [existingCalculation]="currentSelectedCalculation"
        [language]="language"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-ratio-row>
</ham-modal>

<!-- Calculations For Columns -->
<ham-modal
    *ngIf="openSummationColumnDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_summation' | i18next }}"
    titleIcon="sigma-icon"
    [saveText]="
        currentCalculationOutput != null && currentCalculationOutput.columnSelections.length !== 0
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationColumn()"
>
    <super-table-summation-column
        [rowSelectionOptions]="rowSelections"
        [columnSelectionOptions]="columnSelections"
        [existingCalculation]="currentSelectedCalculation"
        [language]="language"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-summation-column>
</ham-modal>

<ham-modal
    *ngIf="openSubtractionColumnDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_subtraction' | i18next }}"
    titleIcon="minus-icon"
    [saveText]="
        currentCalculationOutput != null &&
        currentCalculationOutput.columnSelections[0] != null &&
        currentCalculationOutput.columnSelections[1] != null
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationColumn()"
>
    <super-table-subtraction-column
        [rowSelectionOptions]="rowSelections"
        [columnSelectionOptions]="columnSelections"
        [existingCalculation]="currentSelectedCalculation"
        [language]="language"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-subtraction-column>
</ham-modal>

<ham-modal
    *ngIf="openRatioColumnDialog"
    title=" {{ 'aumico_notes_super_table_add_calculation_function_ratio' | i18next }}"
    titleIcon="chart-pie-outline-icon"
    [saveText]="
        currentCalculationOutput != null &&
        currentCalculationOutput.columnSelections[0] != null &&
        currentCalculationOutput.relationItem != null
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationColumn()"
>
    <super-table-ratio-column
        [rowSelectionOptions]="rowSelections"
        [columnSelectionOptions]="columnSelections"
        [existingCalculation]="currentSelectedCalculation"
        [language]="language"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-ratio-column>
</ham-modal>

<ham-modal
    *ngIf="openMultiplicationColumnDialog"
    title="{{ 'aumico_notes_super_table_add_calculation_function_multiplication' | i18next }}"
    titleIcon="x-outline-icon"
    [saveText]="
        currentCalculationOutput != null && currentCalculationOutput.columnSelections.length !== 0
            ? ('aumico_notes_super_table_add_calculation_button' | i18next)
            : undefined
    "
    [showCancelButton]="'true'"
    [cancelText]="'aumico_notes_super_table_add_calculation_cancel' | i18next"
    (cancel)="onCancelCalculation(currentSelectedCalculation == null)"
    [size]="'xl'"
    (save)="onSaveCalculationColumn()"
>
    <super-table-multiplication-column
        [rowSelectionOptions]="rowSelections"
        [columnSelectionOptions]="columnSelections"
        [existingCalculation]="currentSelectedCalculation"
        [language]="language"
        (calculationOutput)="currentCalculationOutput = $event"
    >
    </super-table-multiplication-column>
</ham-modal>

<ham-modal
    *ngIf="showAddNewSegementDialog"
    title=" {{ 'aumico_notes_super_table_add_row_menu_option_create_segments' | i18next }}"
    [saveText]="'aumico_notes_super_table_create_segment_save_button' | i18next"
    [showCancelButton]="false"
    (cancel)="onCancelSegmentCreation()"
    [size]="'l'"
    (save)="onSegementCreate()"
>
    <super-table-create-segment-form
        [segmentToEdit]="segmentToEdit"
        [language]="language"
        [columnSelectionOptions]="columnOptions"
        (formValueChange)="onSegmentFormValueCreationChange($event)"
    >
    </super-table-create-segment-form>
</ham-modal>

<ham-modal
    *ngIf="showAddFreeColumnDialog"
    title=" {{ 'aumico_notes_super_table_add_column_menu_option_add_column' | i18next }}"
    [saveText]="'aumico_notes_super_table_add_column' | i18next"
    [showCancelButton]="false"
    (cancel)="onCancelFreeColumnCreation()"
    [size]="'l'"
    (save)="onCreateFreeColumn()"
    [disabled]="!freeColumnFormIsValid"
>
    <super-table-add-free-column-form
        [columnData]="freeColumnFormValue"
        (formValueChanged)="onFreeColumnFormValueCreationChange($event)"
        (formStatusChange)="freeColumnFormIsValid = $event"
    >
    </super-table-add-free-column-form>
</ham-modal>

<!-- Row Context Menu Flyout -->
<div
    class="super-table-flyout"
    hamFlyout
    *ngIf="isRowContextFlyoutOpen"
    [position]="rowContextFlyoutPosition"
    (closeFlyout)="closeRowContextFlyout()"
>
    <div class="flyout-content">
        <div class="flyout-body">
            <!-- Add row context menu content here -->
            <div
                class="context-option"
                (click)="toggleRowStylingMenu(activeContextMenuRow)"
                *ngIf="form.get('rows')['controls'][activeContextMenuRow]?.get('type').value !== 'SPACE'"
            >
                <span
                    hamIconShapes
                    class="icon export-icon"
                    icon="assets/hamIcons/italic.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                ></span>
                <span class="label export-button">{{ 'aumico_notes_super_table_row_format' | i18next }}</span>
            </div>
            <div
                class="context-option"
                *ngIf="
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'GROUP' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'FLI' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'SUB FLI' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'OF_THAT_ITEM' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'SUB_TOTAL' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'ACCOUNT' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'CALC' ||
                    form.get('rows')['controls'][activeContextMenuRow]?.get('type').value === 'UNDEFINED'
                "
                (click)="onEditRowSelectionClick(activeContextMenuRow)"
            >
                <span
                    hamIconShapes
                    class="icon export-icon"
                    icon="assets/hamIcons/edit-outline.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                ></span>
                <span class="label export-button">{{ 'aumico_notes_super_table_edit_row' | i18next }}</span>
            </div>
            <div
                class="context-option"
                (click)="onReconcileClick()"
                *ngIf="form.get('rows')['controls'][activeContextMenuRow]?.get('type').value !== 'SPACE'"
            >
                <span
                    hamIconShapes
                    class="icon export-icon"
                    icon="assets/hamIcons/file-check-outline.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                ></span>
                <span
                    *ngIf="
                        form.get('rows')['controls'][activeContextMenuRow]?.value.reconcileItems == null ||
                        form.get('rows')['controls'][activeContextMenuRow].value.reconcileItems.length === 0
                    "
                    class="label export-button"
                    >{{ 'aumico_notes_super_table_reconcile' | i18next }}</span
                >
                <span
                    *ngIf="
                        form.get('rows')['controls'][activeContextMenuRow]?.value.reconcileItems != null &&
                        form.get('rows')['controls'][activeContextMenuRow]?.value.reconcileItems.length > 0
                    "
                    class="label export-button"
                    >{{ 'aumico_notes_super_table_edit_reconcile' | i18next }}</span
                >
            </div>
            <div class="divider"></div>
            <div class="context-option remove" (click)="removeRow(activeContextMenuRow)">
                <span
                    hamIconShapes
                    class="icon export-icon"
                    icon="assets/hamIcons/minus-outline.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                ></span>
                <span class="label export-button">{{ 'aumico_notes_super_table_remove_row' | i18next }}</span>
            </div>
        </div>
    </div>
</div>

<!-- Column Context Menu Flyout -->
<div
    class="super-table-flyout"
    hamFlyout
    *ngIf="isColumnContextFlyoutOpen"
    [position]="columnContextFlyoutPosition"
    (closeFlyout)="closeColumnContextFlyout()"
>
    <div class="flyout-content">
        <div class="flyout-content">
            <div class="flyout-body">
                <!-- Add row context menu content here -->
                <div class="context-option" (click)="toggleColumnStylingMenu(activeContextMenuColumn)">
                    <span
                        hamIconShapes
                        class="icon export-icon"
                        icon="assets/hamIcons/italic.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    ></span>
                    <span class="label export-button">{{ 'aumico_notes_super_table_column_format' | i18next }}</span>
                </div>
                <div
                    class="context-option"
                    (click)="onColumnEdit(xAxisConfigCols[activeContextMenuColumn], activeContextMenuColumn)"
                >
                    <span
                        hamIconShapes
                        class="icon export-icon"
                        icon="assets/hamIcons/edit-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    ></span>
                    <span class="label export-button">{{ 'aumico_notes_super_table_edit_column' | i18next }}</span>
                </div>

                <div class="divider"></div>
                <div class="context-option remove" (click)="removeColumnByIndex(activeContextMenuColumn)">
                    <span
                        hamIconShapes
                        class="icon export-icon"
                        icon="assets/hamIcons/minus-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    ></span>
                    <span class="label export-button">{{ 'aumico_notes_super_table_remove_column' | i18next }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
